module.exports = __webpack_public_path__ + "static/images/cover_D5.cca6286.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_D5.png
// module id = uU/J
// module chunks = 8